import template from './editable-symptom.tpl';
import './editable-symptom.css';

const EditableSymptom = DomClass(template, function() {
});

export default EditableSymptom;